export default __webpack_public_path__ + "static/talcum-14c7523f5a438bf5762617d9dbaa09ad.png";